import React from "react";
import { connect } from "react-redux";
import { Popup, Button } from "devextreme-react";
import { openCloseModalEliminarSolicitud, setSolicitudesEmpresaFiltrada, loadDataGrid } from "./actions";
import { formatDateForFilter } from "../../../../../helpers/dateFormat";
import moment from "moment";
import validaciones from "../../../../../helpers/validaciones";


import { DeleteSolicitudApi } from "../../../../../services/solicitudesAgendaSelApi";

class ModalEliminarSolicitud extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }
  handleClose = () => {
    const { onOpen } = this.props;
    onOpen(false, {});
    this.setState({ loading: false });
  }
  handleDeleteRow = () => {
    this.setState({ loading: true });
    this.deleteRow();
  }
  async deleteRow() {
    const { request: requestStatus } = this.props;
    try {
      const request = await DeleteSolicitudApi(requestStatus);

      if (request.status === 200 || true) {
        this.updateData();
        this.setState({ loading: false });
        return;
      }
    } catch (err) {
      this.updateData();
      this.setState({ loading: false });
    }
  }
  updateData = () => {
    this.doGetComplains();
  }
  doGetComplains = (data) => {
    const {
      onOpen, onSetSolicitudesEmpresaFiltrada, onLoadDataGrid, companyId, userData, sucursalId, selectedTipoSolicitud,
    } = this.props;
    onSetSolicitudesEmpresaFiltrada([]);
    const filtros = {
      from: formatDateForFilter(moment().subtract(1, "year")),
      to: formatDateForFilter(moment()),
      companyRut: companyId,
      PetitionerRut: userData.RUT,
      StatusId: selectedTipoSolicitud.value.value, // borrador
    };
    if (validaciones.emptyText(sucursalId)) {
      filtros.idSucursal = sucursalId;
    }
    onOpen(false, {});
    onLoadDataGrid(filtros);
  }
  render() {
    return (
      <Popup
        title="Eliminar solicitud"
        showCloseButton
        dragEnabled={false}
        onHiding={this.handleClose}
        visible={this.props.isOpenModalEliminarSolicitud}
        width={500}
        height={200}
        contentComponent={() => (
          <div style={{ textAlign: "center" }} className="modal-delete-mantenedor">
            ¿Estás seguro que quieres eliminar la solicitud?
            <div className="button-row">
              <div>
                <Button text="Cancelar" style={{ marginRight: 5 }} onClick={this.handleClose} />
              </div>
              <div>
                <Button text="Eliminar" type="danger" onClick={() => this.handleDeleteRow()} useSubmitBehavior />
              </div>
            </div>
          </div >
        )
        }
      />
    );
  }
}
const mapStateToProps = (state) => ({
  isOpenModalEliminarSolicitud: state.solicitudesAgendaSel.isOpenModalEliminarSolicitud,
  dataSolicitudAgendaSel: state.solicitudesAgendaSel.dataSolicitudAgendaSel,
  isLoading: state.solicitudesAgendaSel.isLoading,
  request: state.solicitudesAgendaSel.request,
  companyId: state.global.companyId,
  selectedTipoSolicitud: state.solicitudesAgendaSel.selectedTipoSolicitud,
  sucursalId: state.global.sucursalId,
  userData: state.global.userData,

});
const mapDispatchToProps = (dispatch) => ({
  onOpen: (open, request) => dispatch(openCloseModalEliminarSolicitud(open, request)),
  onSetSolicitudesEmpresaFiltrada: (lista) => dispatch(setSolicitudesEmpresaFiltrada(lista)),
  onLoadDataGrid: (filtro) => dispatch(loadDataGrid(filtro)),
  // onSetDataSolicitudAgenda: (data) => dispatch(setDataSolicitudAgenda(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(ModalEliminarSolicitud);
